import React, { useMemo } from "react";
import _ from "lodash";
import { Line } from "recharts";
import { SpecimensPerWeekGraph } from "./SpecimensPerWeekGraph";

const NUM_MONTHS = 4;
const SECONDS_IN_A_MONTH = 30 * 24 * 60 * 60 * 1000;

const formatMonth = (month) => {
  const date = new Date(month);
  return date.toLocaleString("en-us", { month: "long", day: "numeric" });
};

const Index = ({ data }) => {
  const graphData = useMemo(() => {
    if (data.length === 0) return [];
    const fewMonthsAgo = new Date() - NUM_MONTHS * SECONDS_IN_A_MONTH; // Approximate few months ago
    const lastFewMonths = _(data)
      .filter((x) => new Date(x.date) > fewMonthsAgo)
      .orderBy((x) => new Date(x.date), "asc")
      .value();
    return lastFewMonths.map((monthData) => ({
      name: formatMonth(monthData.date),
      total: monthData.count,
    }));
  }, [data]);

  const lines = useMemo(
    () => [
      <Line
        key={0}
        type="monotone"
        dataKey="total"
        stroke="#167bc3"
        activeDot={{ r: 8 }}
      />,
    ],
    []
  );

  return <SpecimensPerWeekGraph graphData={graphData} lines={lines} />;
};

export default Index;
